import { createFileRoute } from "@tanstack/react-router";
import { TutorsSavedPage } from "@/components/partners/TutorsSavedPage";
import { tutorsSavedHead } from "@/components/partners/tutors-saved-head";
import { loadTutorsHub } from "@/components/partners/partner-route";

// ♥ Сохранённые анкеты карты (ru): список браузера или ?ids= из WhatsApp. noindex, в sitemap нет.
export const Route = createFileRoute("/ru/tutors/saved")({
  loader: () => loadTutorsHub(),
  head: () => tutorsSavedHead("ru"),
  component: function Page() {
    const { list } = Route.useLoaderData();
    return <TutorsSavedPage lang="ru" initial={list} />;
  },
});
